(function () {
  Flint.file('mframework/views/mediaChooser.js', function (require) {
    Flint.view('MediaChooser', function (view, on, $) {
      var context = initContext(view, {
        isAdmin: atom()
      });

      var pro = initPro(view, {
        initialMediaKey: M.defaultAtom(null),
        editable: M.defaultAtom(false),
        width: M.defaultAtom(300),
        height: M.defaultAtom(300),
        allowUpload: M.defaultAtom(true),
        allowFacebook: M.defaultAtom(false),
        circle: M.defaultAtom(false),
        mediaStyle: M.mapAtom({}),
        noMediaStyle: M.mapAtom({}),
        zoomable: M.defaultAtom(false),

        children: atom()
      });

      var mediaKey = atom(pro.initialMediaKey.get());
      mediaKey.reactor(function (mediaKey) {
        if (view.props.onSelect) {
          view.props.onSelect({ mediaKey: mediaKey });
        }
      }).start();

      var picKey = mediaKey.lens({
        get: function get(mediaKey) {
          return mediaKey && mediaKey.indexOf('pics/') == 0 ? mediaKey : null;
        },
        set: function set(mediaKey, picKey) {
          return picKey;
        }
      });
      var videoKey = mediaKey.lens({
        get: function get(mediaKey) {
          return mediaKey && mediaKey.indexOf('videos/') == 0 ? mediaKey : null;
        },
        set: function set(mediaKey, videoKey) {
          return videoKey;
        }
      });view.render(function () {
        return Flint.iff(!videoKey.get()) && view.el(
          ['PicChooser', 1],
          { if: !videoKey.get(),
            initialPicKey: picKey.get(),
            editable: pro.editable.get(),
            width: pro.width.get(),
            height: pro.height.get(),
            circle: pro.circle.get(),
            picStyle: pro.mediaStyle.get(),
            noPicStyle: pro.noMediaStyle.get(),
            zoomable: pro.zoomable.get(),
            onSelect: function (e) {
              return picKey.set(e.picKey);
            },
            onZoomIn: view.props.onZoomIn,
            onZoomOut: view.props.onZoomOut
          },
          pro.children.get()
        );
      });view.render(function () {
        return Flint.iff(!picKey.get()) && view.el(
          ['VideoChooser', 1],
          { if: !picKey.get(),
            initialVideoKey: videoKey.get(),
            editable: pro.editable.get()

            // Only admins can edit video media right now because the UI is crude
             && context.isAdmin.get(),
            circle: pro.circle.get(),
            width: pro.width.get(),
            height: pro.height.get(),
            videoStyle: pro.mediaStyle.get(),
            noVideoStyle: pro.noMediaStyle.get(),
            zoomable: pro.zoomable.get(),
            onSelect: function (e) {
              return videoKey.set(e.videoKey);
            },
            onZoomIn: view.props.onZoomIn,
            onZoomOut: view.props.onZoomOut
          },
          pro.children.get()
        );
      });
    });
  })
})();
//# sourceMappingURL=mediaChooser.js.map
